<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        新規登録
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        または
        <router-link to="/login" class="font-medium text-blue-600 hover:text-blue-500">
          ログインする
        </router-link>
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form @submit.prevent="handleRegister" class="space-y-6">
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              メールアドレス
            </label>
            <div class="mt-1">
              <input
                v-model="form.email"
                id="email"
                name="email"
                type="email"
                autocomplete="email"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              パスワード（8文字以上）
            </label>
            <div class="mt-1">
              <input
                v-model="form.password"
                id="password"
                name="password"
                type="password"
                autocomplete="new-password"
                required
                minlength="8"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label for="password_confirm" class="block text-sm font-medium text-gray-700">
              パスワード確認
            </label>
            <div class="mt-1">
              <input
                v-model="form.password_confirm"
                id="password_confirm"
                name="password_confirm"
                type="password"
                autocomplete="new-password"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label for="sport_type" class="block text-sm font-medium text-gray-700">
              スポーツタイプ（任意）
            </label>
            <div class="mt-1">
              <select
                v-model="form.sport_type"
                id="sport_type"
                name="sport_type"
                class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              >
                <option value="">選択してください</option>
                <option value="パラグライダー">パラグライダー</option>
                <option value="ハンググライダー">ハンググライダー</option>
                <option value="グライダー">グライダー</option>
                <option value="気球">気球</option>
              </select>
            </div>
            <p class="mt-1 text-sm text-gray-500">
              後からアカウント設定で変更できます
            </p>
          </div>

          <div v-if="errorMessage" class="text-red-600 text-sm">
            {{ errorMessage }}
          </div>

          <div v-if="successMessage" class="text-green-600 text-sm">
            {{ successMessage }}
          </div>

          <div>
            <button
              type="submit"
              :disabled="isLoading"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
            >
              {{ isLoading ? '登録中...' : '新規登録' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'Register',
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()
    
    const form = ref({
      email: '',
      password: '',
      password_confirm: '',
      sport_type: ''
    })
    
    const errorMessage = ref('')
    const successMessage = ref('')
    const isLoading = ref(false)

    const handleRegister = async () => {
      if (isLoading.value) return
      
      errorMessage.value = ''
      successMessage.value = ''
      isLoading.value = true

      if (form.value.password !== form.value.password_confirm) {
        errorMessage.value = 'パスワードが一致しません'
        isLoading.value = false
        return
      }

      try {
        await authStore.register(form.value)
        successMessage.value = 'ユーザー登録が完了しました。ログインしてください。'
        setTimeout(() => {
          router.push('/login')
        }, 2000)
      } catch (error) {
        if (error.response?.data) {
          const errors = error.response.data
          if (errors.email) {
            errorMessage.value = errors.email[0]
          } else if (errors.password) {
            errorMessage.value = errors.password[0]
          } else {
            errorMessage.value = '登録に失敗しました'
          }
        } else {
          errorMessage.value = '登録に失敗しました'
        }
      } finally {
        isLoading.value = false
      }
    }

    return {
      form,
      errorMessage,
      successMessage,
      isLoading,
      handleRegister
    }
  }
}
</script>